import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

export default function SubscriptionSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const session = params.get('session_id');
  const [state, setState] = useState('pending');
  const [returnTo, setReturnTo] = useState('/settings');
  useEffect(() => {
    let stopped = false;
    let timer;
    let attempts = 0;
    async function check() {
      if (!session || !/^cs_[\w-]+$/.test(session)) { setState('invalid'); return; }
      try {
        const r = await axios.get(`${API}/subscriptions/checkout-status/${encodeURIComponent(session)}`);
        if (stopped) return;
        if (r.data.owner_type === 'organization') setReturnTo('/teams');
        if (r.data.active) { setState('active'); return; }
        if (r.data.status === 'expired') { setState('expired'); return; }
      } catch (e) {
        if (stopped) return;
        if ([403, 404].includes(e.response?.status)) { setState('invalid'); return; }
      }
      attempts += 1;
      if (attempts < 10) timer = setTimeout(check, 2500);
      else setState('delayed');
    }
    check();
    return () => { stopped = true; clearTimeout(timer); };
  }, [session]);
  return <div className="min-h-screen bg-black flex items-center justify-center p-6">
    <Card className="glass p-8 text-center max-w-lg w-full">
      <h1 className="text-2xl font-bold text-white mb-4">Subscription Checkout</h1>
      {state === 'active' && <p className="text-emerald-300">Your recurring subscription is active.</p>}
      {state === 'pending' && <p className="text-stone-300">Confirming subscription with Stripe…</p>}
      {state === 'delayed' && <p className="text-amber-300">Confirmation is still pending. Check Billing in your settings shortly; do not start a second payment.</p>}
      {state === 'expired' && <p className="text-amber-300">This checkout session has expired.</p>}
      {state === 'invalid' && <p className="text-stone-300">This checkout is unavailable to your account.</p>}
      <Button onClick={() => navigate(returnTo)} className="mt-6 bg-amber-700 text-white">{returnTo === '/teams' ? 'Back to Teams' : 'Back to Settings'}</Button>
    </Card>
  </div>;
}
